
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import EventCard from "../components/EventCard"

/*
  TODO: удалить ссылку на useToposPostsStore. Заменить на реальный источник [FestivalSite]
*/
const Day = (props: any) : JSX.Element => { 
  
  const lands:ILand[] = useDataStore((state: any) => state.Land)
  return <div >
    <div className=" d-flex justify-content-center position-relative " >
      <div className="row w-100">
      { 
        lands.map( event => <EventCard item={event} key={event.id} height={420} /> )
      }  
      </div>
    </div> 
  </div>
} 
export default Day
 